import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_52: DocMigration = {
  maxSchemaVersion: "0.0.52",
  apply(json: any) {
    if (json.wallSweepTable) {
      delete json.wallSweepTable;
    }
    return json;
  },
};

export default migration_0_0_52;
